import { render } from "./IndexPacha.vue?vue&type=template&id=eaacb0aa"
import script from "./IndexPacha.vue?vue&type=script&lang=js"
export * from "./IndexPacha.vue?vue&type=script&lang=js"

import "./IndexPacha.vue?vue&type=style&index=0&id=eaacb0aa&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__